"use client";

import { ILayout } from "@/types/common";
import React from "react";

const Layout: React.FC<ILayout> = ({ children }) => {
  return <section className="w-full h-auto mx-auto pb-24">{children}</section>;
};

export default Layout;
